
import jaMessages from '../locales/ja_JA';

const JsLang = {
    messages: {
        ...jaMessages
    },
    locale: 'ja-JA',
    
};
export default JsLang;